module.exports = __webpack_public_path__ + "img/extend-bg.60b6f5fe.png";